<template>
  <el-col :span="17" style="height: 100%">
    <div class="coreData">
      <!-- pop 版本 -->
      <div class="head flex">
        <div class="left flex">
          <h4>核心数据</h4>
          <el-tooltip v-if="venderType" popper-class="popClass" class="item" effect="light"  placement="right-start">
            <div slot="content" style="color:#666; font-size:12px">
              <div style="margin-bottom:5px">1.数据的用户范围为“开卡会员+已购用户”</div>
              <div style="margin-bottom:5px">2.会员总数：已购+开卡用户会员</div>
              <div style="margin-bottom:5px">3.下单人数：已购会员</div>
              <div style="margin-bottom:5px">4.关注店铺人数：会员总数中并且关注店铺了的人数</div>
              <div style="margin-bottom:5px">5.开卡会员：就是在店铺开卡了的会员</div>
              </div>
            <div  class="explain">?</div>
          </el-tooltip>
          <p v-if="!venderType" class="time">更新时间：{{ orderData.updateTime }}</p>
        </div>
        <div class="right" style="display:flex;align-items: center;" v-if="venderType">
          <p v-if="venderType" class="time" style="margin-right:6px">更新时间：{{ currentdate }}</p>
          <el-button class="btn" @click="getSelfSupport">刷新</el-button>
        </div>
        <div class="right" v-if="!venderType">
          <el-button
            @click="dateActive(index)"
            v-for="(item, index) in date"
            :class="['btn', { active: active == index }]"
            :key="index"
            >{{ item.tit }}</el-button
          >
        </div>
      </div>
      <ul v-if="!venderType" class="foot flex">
        <li>
          <span class="txt">支付金额(元)</span>
          <span class="num">{{ orderData.orderPayment }}</span>
          <div class="btm">
            <p>
              较前{{ preData }}日
              <i
                v-if="orderData.comparePayment > 0"
                class="el-icon-caret-top red"
              ></i>
              <i v-else class="el-icon-caret-bottom green"></i>
            </p>
            <span
              :class="{
                red: orderData.comparePayment >= 0,
                green: orderData.comparePayment < 0,
              }"
              >{{ orderData.comparePayment }}</span
            >
          </div>
        </li>
        <li>
          <span class="txt">支付买家数</span>
          <span class="num">{{ orderData.orderBuyerNum }}</span>
          <div class="btm">
            <p>
              较前{{ preData }}日
              <i
                v-if="orderData.compareBuyerNum > 0"
                class="el-icon-caret-top red"
              ></i>
              <i v-else class="el-icon-caret-bottom green"></i>
            </p>
            <span
              :class="{
                red: orderData.compareBuyerNum >= 0,
                green: orderData.compareBuyerNum < 0,
              }"
              >{{ orderData.compareBuyerNum }}</span
            >
          </div>
        </li>
        <li>
          <span class="txt">客单价</span>
          <span class="num">{{ orderData.customerPrice }}</span>
          <div class="btm"></div>
        </li>
        <li>
          <span class="txt">退款金额(元)</span>
          <span class="num">{{ orderData.applyRefundSum }}</span>
          <div class="btm"></div>
        </li>
        <li>
          <span class="txt">订单总数</span>
          <span class="num">{{ orderData.totalOrderNum }}</span>
          <div class="btm">
            <p>
              较前{{ preData }}日
              <i
                v-if="orderData.compareOrderNum > 0"
                class="el-icon-caret-top red"
              ></i>
              <i v-else class="el-icon-caret-bottom green"></i>
            </p>
            <span
              :class="{
                red: orderData.compareOrderNum >= 0,
                green: orderData.compareOrderNum < 0,
              }"
              >{{ orderData.compareOrderNum }}</span
            >
          </div>
        </li>
        <li>
          <span class="txt">会员总数</span>
          <span class="num">{{ orderData.totalPinNum }}</span>
          <div class="btm">
            <p>
              较前{{ preData }}日
              <i
                v-if="orderData.comparePinNum > 0"
                class="el-icon-caret-top red"
              ></i>
              <i v-else class="el-icon-caret-bottom green"></i>
            </p>
            <span
              :class="{
                red: orderData.comparePinNum >= 0,
                green: orderData.comparePinNum < 0,
              }"
              >{{ orderData.comparePinNum }}</span
            >
          </div>
        </li>
      </ul>
      <!-- 自营版本 -->
      <div class="self-support">
        <div class="self-box flex">
          <div class="self-item flex">
            <img src="@/assets/images/home/icon_self_1.png" alt="" />
            <div class="data">
              <div class="num">{{ ownData.memberCount }}</div>
              <div class="text">会员总数</div>
            </div>
          </div>
          <div class="self-item flex">
            <img src="@/assets/images/home/icon_self_2.png" alt="" />
            <div class="data">
              <div class="num">{{ ownData.orderMemberCount }}</div>
              <div class="text">下单人数</div>
            </div>
          </div>
          <div class="self-item flex">
            <img src="@/assets/images/home/icon_self_3.png" alt="" />
            <div class="data">
              <div class="num">{{ ownData.followShopCount }}</div>
              <div class="text">关注店铺（人）</div>
            </div>
          </div>
          <div class="self-item flex">
            <img src="@/assets/images/home/icon_self_4.png" alt="" />
            <div class="data">
              <div class="num">{{ ownData.cardMemberCount }}</div>
              <div class="text">开卡会员</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
import { getCoreData, getBusinessCoreData } from "@/api/homePage";

export default {
  props: {
    typeVersion: {
      type: Number,
      default: 1, // 1.表示pop 版本 2.表示自营版本
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    currentdate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      return currentdate;

      // this.$refs.searchForm.submitForm("formSearch");
    },
  },

  data() {
    return {
      date: [{ tit: "昨天" }, { tit: "近7天" }, { tit: "近30天" }],
      active: 1,
      orderData: {},
      preData: 1,
      ownData: {},
    };
  },
  mounted() {
    this.dateActive(1);
    this.getSelfSupport();
  },
  methods: {
    //右上角日期选择
    dateActive(index) {
      // console.log(index);
      this.active = index;
      if (index == "0") {
        this.preData = 1;
      } else if (index == "1") {
        this.preData = 7;
      } else if (index == "2") {
        this.preData = 30;
      }
      this.getData();
    },
    // 获取核心数据
    getData() {
      /** 获取核心数据 */
      var param = {
        type: this.active + 1, // 1昨日 2近7天 3近30天
      };
      getCoreData(param).then((res) => {
        if (res.code == "1") {
          this.orderData = res.data;
        }
      });
    },

    // 获取核心数据（自营）
    getSelfSupport() {
      getBusinessCoreData().then((res) => {
        if (res.code == "1") {
          this.ownData = res.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
}
.self-support {
  .self-box {
    .self-item {
      flex: 1;
      height: 141px;
      padding-left: 40px;
      @media screen and (min-width: 1500px) and (max-width: 1700px) {
        padding-left: 35px;
      }
      @media screen and (min-width: 1321px) and (max-width: 1499px) {
        padding-left: 30px;
      }
      @media screen and (max-width: 1320px) {
        padding-left: 20px;
      }
      color: #000000;
      // font-family: PingFang SC;
      font-weight: 800;
      border-right: 1px solid #f0f0f0;
      img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        @media screen and (min-width: 1500px) and (max-width: 1700px) {
          margin-right: 16px;
        }
        @media screen and (min-width: 1341px) and (max-width: 1499px) {
          margin-right: 14px;
        }
        @media screen and (max-width: 1340px) {
          margin-right: 10px;
        }
      }
      .data {
        display: inline-block;
        .num {
          color: #333;
          font-size: 28px;
          @media screen and (min-width: 1500px) and (max-width: 1700px) {
            font-size: 26px;
          }
          @media screen and (min-width: 1341px) and (max-width: 1499px) {
            font-size: 25px;
          }
          @media screen and (max-width: 1340px) {
            font-size: 24px;
          }
          font-weight: bold;
        }
        .text {
          color: #666;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
}

.coreData {
  padding: 0 !important;
  height: 100%;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  .popClass{
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12) !important;
  }
  .explain{
    width: 14px;
    height: 14px;
    padding: 3px;
    text-align: center;
    line-height: 6px;
    border-radius: 50%;
    color: #ccc;
    font-size: 12px;
    margin-left: 8px;
    border: 1px solid #ccc;
    cursor: default;
  }
  .head {
    box-sizing: border-box;
    padding: 0 12px 0 24px;
    height: 54px;
    border-bottom: 1px solid #f6f6f6;
    justify-content: space-between;
    .left {
      h4 {
        margin: 0;
        color: #252c38;
        font-size: 16px;
      }
      .time {
        margin: 0px 0 0 8px;
        color: #999;
        font-size: 12px;
      }
    }
    .right {
      padding: 8px 2px;
      color: #999;
      cursor: pointer;
      .btn {
        width: 60px;
      }
      .active {
        color: #fe4d45;
        background: #fff4f4;
        border: 1px solid #fe4d45;
      }
    }
  }
  .foot {
    list-style: none;
    height: 142px;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      position: relative;
      box-sizing: border-box;
      flex: 1;
      height: 100%;
      padding: 15px 10px 13px 14px;
      border-right: 1px solid #f6f6f6;
      .txt {
        color: #666;
        font-size: 14px;
        font-weight: 500;
      }
      .num {
        color: #333;
        font-size: 24px;
        font-weight: 800;
      }
      .btm {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        height: 20px;
        i {
          width: 11px;
          height: 10px;
          font-size: 18px;
        }
        p {
          margin: 0;
          color: #333;
          font-size: 14px;
        }
        span {
          font-size: 14px;
        }
        .red {
          color: #fe4d45;
        }
        .green {
          color: #49c568;
        }
      }
    }
    li::before {
      content: "";
      height: 4px;
      background-color: #fe4d45;
      position: absolute;
      left: 51%;
      right: 51%;
      top: 0;
      transition-property: left, right;
      transition-duration: 0.3s;
      transition-timing-function: ease-out;
    }
    li:hover::before {
      left: 0;
      right: 0;
    }
    li:last-child {
      border: none;
    }
  }
}
</style>